/**
 * 菜单组件路径工具
 * =============================================
 * 菜单的 `componentPath` 是路由组件路径的唯一来源（相对 `src/views/`）。
 * 历史/线上数据可能存在两种形态：旧版只有 `component` 字段，新版约定 `componentPath`。
 * 这里统一以 `componentPath` 优先、`component` 兜底的方式读取，保证兼容。
 */

/**
 * 读取菜单节点对应的组件路径（componentPath 优先，兜底兼容旧 component 字段）。
 * @param {Object} menu 菜单节点
 * @returns {string} 组件路径（可能为空串）
 */
export function getMenuComponentPath(menu) {
  if (!menu) {
    return ''
  }

  const path = menu.componentPath || menu.component
  return typeof path === 'string' ? path : ''
}
